import type { ApiDocument } from "@workith/shared";
import { Badge } from "@workith/ui";

interface DocumentVisibilityBadgeProps {
  visibility: ApiDocument["visibility"];
}

export function DocumentVisibilityBadge({ visibility }: DocumentVisibilityBadgeProps) {
  return <Badge variant={visibility === "public" ? "default" : "secondary"}>{visibility}</Badge>;
}
